<template>
    <Main>
        <div slot="main" class="main details">
            <div class="bank_title">
                <Header :data='headerInfo'></Header>
                <div class="gobcak" @click="goBack"><img src="../../assets/return.png" alt=""><span>返回</span></div>
            </div>
            <div class="content">
                <div class="left">
                    <div class="server" style="width:6.25rem">
                        <div>
                            <span class="card_">养殖户基础信息</span>
                            <img style="margin-left: 0.25rem;" src="../../assets/hhr_right.png" alt="">
                        </div>
                    </div>
                    <div class="info">
                        <div class="img_box">
                            <img src="../../assets/people.png" alt="">
                        </div>
                        <div class="info_ info_n">
                            <div>
                                <span>姓名：</span>
                                <span>{{ info.farmerName }}</span>
                            </div>
                            <div>
                                <span>联系电话：</span>
                                <span>{{ info.phone }}</span>
                            </div>
                            <div>
                                <span>养殖户类型：</span>
                                <span>{{ info.farmerType }}</span>
                            </div>
                        </div>
                        <div class="info_ info_a">
                            <div>
                                <span>养殖方式：</span>
                                <span>{{ info.breedingMethod }}</span>
                            </div>
                            <div>
                                <span>所属畜牧科技师：</span>
                                <span>{{ info.rearLiveStock }}</span>
                            </div>
                            <div style="height: 0.2rem;line-height: .2rem;">
                                <span>所在区域：</span>
                                <span>{{ info.address }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="server video_title" style="width:6.25rem">
                        <div>
                            <span class="card_">牧场实时监控</span>
                            <img style="margin-left: 0.25rem;" src="../../assets/hhr_right.png" alt="">
                        </div>
                        <!-- v-if="this.deviceList>1"临时隐藏·························· -->
                        <el-dropdown v-if="this.firstList && this.firstList.length > 1" @command="selectLive"
                            trigger="click">
                            <span style="margin-left: .1rem" class="el-dropdown-link">
                                <!-- {{ currentDeviceInfo.mountLocation || '切换视频' }}<i
                                                                            class="el-icon-arrow-down el-icon--right"></i> -->
                                {{ command }}<i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu style="border: none!important;" slot="dropdown">
                                <template v-if="videoList.length > 1">
                                    <el-dropdown-item v-for="(item, index) in firstList" :key="index" :command='item'>
                                        {{ item.pastureName }}</el-dropdown-item>
                                </template>
                                <!-- <template v-else>
                                                                            <el-dropdown-item>
                                                                                {{ house[0] }}</el-dropdown-item>
                                                                        </template> -->
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div class="box">
                        <div class="video_info">
                            <div class="video_item">
                                <img src="../../assets/v_1 (1).png" alt="">
                                <span>气温：</span>
                                <span>{{ videoListItem.airTemperature }}</span>
                            </div>
                            <div class="video_item" style="margin-top:.43rem">
                                <img src="../../assets/v_1 (3).png" alt="">
                                <span>气压：</span>
                                <span>{{ videoListItem.airPressure }}</span>
                            </div>
                        </div>
                        <div class="video_info" style="margin-left:1.7rem">
                            <div class="video_item">
                                <img src="../../assets/v_1 (2).png" alt="">
                                <span>湿度：</span>
                                <span>{{ videoListItem.dampWarm }}</span>
                            </div>
                            <div class="video_item" style="margin-top:.43rem">
                                <img src="../../assets/v_1 (4).png" alt="">
                                <span>海拔：</span>
                                <span>{{ videoListItem.elevation + '米' }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="quan">
                        <div class="cattle_">
                            <span></span>
                            <span>{{ currentDeviceInfo.mountLocation }}</span>
                        </div>
                        <div class="screenFull" @click="videoShow">
                            <img src="../../assets/screen.png" alt="">
                            <span style="font-size:.15rem">全屏</span>
                        </div>
                    </div>
                    <div class="device_main">
                        <!-- <div class="sky"></div> -->
                        <div class="video_box">
                            <div class="device_box" ref="device_box">
                                <!-- <img v-if="!videoModelShow" src="../../assets/R-C.jpg" alt="" /> -->
                                <div id="myPlayer" v-if="((currentDeviceInfo.deviceType == 3 && !showImg))"></div>
                                <video
                                    v-else-if="((currentDeviceInfo.deviceType == 1 && !showImg_1) || (currentDeviceInfo.deviceType == 2 && !showImg_2))"
                                    autoplay controls width="100%" height="100%" muted id="myVideo"></video>
                                <div v-else
                                    style="width: 8.15rem;height: 4.65rem;background-color: #000308;display: flex;justify-content: center;align-items: center;flex-direction: column;">
                                    <img src="../../assets/v_img.png" style="width: 2.29rem;height: 2rem;display: block;"
                                        alt="">
                                    <p
                                        style="font-size: 0.15rem;font-family: Source Han Sans CN-Normal, Source Han Sans CN;font-weight: 350;color: #FFFFFF;margin-top: .25rem;margin-left: .3rem;">
                                        暂无视频</p>
                                </div>
                                <!-- <div class="empty" v-if="camerasList.length === 0">
                                                                        <img src="../../assets/camera_empty.png" alt="" srcset="" />
                                                                        <p>暂无视频设备</p>
                                                                    </div> -->
                            </div>
                            <div class="top_box"></div>
                        </div>
                        <!-- <img v-if="camerasList.length != 0" src="../../assets/zoom_icon.png" class="zoom_icon" @click.stop="enlarge" /> -->
                        <!-- <div class="long"><span class="el-icon-arrow-right"></span> </div> -->
                    </div>
                </div>
                <div class="right">
                    <div class="server">
                        <div>
                            <span class="card_">存栏活畜</span>
                            <img style="margin-left: 0.25rem;" src="../../assets/hhr_right.png" alt="">
                        </div>
                    </div>
                    <div class="center">
                        <div class="left_">
                            <span class="hand">活畜存栏量</span>
                            <ul>
                                <li v-for="(item, i) in numberList" :key="i">{{ item }}</li>
                            </ul>
                            <div class="box1">
                                <div class="box_">
                                    <div class="box_item">
                                        <!-- <span>{{ countList.cowQuantity }}</span> -->
                                        <span>{{ countList.liveStockQuantity }}</span>
                                        <span>存栏牛只(头)</span>
                                    </div>
                                    <!-- <div class="box_item" style="margin-top:.48rem">
                                        <span>{{ countList.sheepQuantity }}</span>
                                        <span>存栏羊只(只)</span>
                                    </div> -->
                                </div>
                                <div class="box_" style="margin-left:1.4rem">
                                    <div class="box_item">
                                        <span>{{ countList.cowFilingAmount }}</span>
                                        <span>建档牛只(头)</span>
                                    </div>
                                    <!-- <div class="box_item" style="margin-top:.48rem">
                                        <span>{{ countList.sheepFilingAmount }}</span>
                                        <span>建档羊只(只)</span>
                                    </div> -->
                                </div>
                                <div class="box_" style="margin-left:1.4rem">
                                    <div class="box_item">
                                        <span style="color:#FFE11D">{{ countList.cowSuperviseAmount }}</span>
                                        <span>正在监管中牛只(头)</span>
                                    </div>
                                    <!-- <div class="box_item" style="margin-top:.48rem">
                                        <span style="color:#FFE11D">{{ countList.sheepSuperviseAmount }}</span>
                                        <span>正在监管中羊只(只)</span>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                        <div class="right_">
                            <div class="r_">
                                <div class="r_l">
                                    <span></span>
                                    <span>存栏活畜品类分布</span>
                                </div>
                                <div class="r_r">
                                    <span @click="serviceStatusBtn('cattle')"
                                        :class="{ active: serviceStatus === 'cattle' }">牛</span>
                                    <span @click="serviceStatusBtn('sheep')" :class="{ active: serviceStatus === 'sheep' }"
                                        v-if="sheep && sheep.length > 0">羊</span>
                                </div>
                            </div>
                            <div class="pie_chart">
                                <dv-active-ring-chart :config="config1" id="pieChart" />
                                <div class="lenged">
                                    <div v-for="(item, i) in assortmentList" :key="i">
                                        <span :style='{
                                            backgroundColor: i == 0 ? "#3AFFFB" : i == 1 ? "#7239EA" : i == 2 ? "#FFC700" : "#165DFF"
                                        }'></span>
                                        <span>{{ item.name }}</span>
                                        <span>{{ item.label }}</span>
                                        <!-- <span>{{ item.value + '头' }}</span> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="table">
                        <div class="search">
                            <el-select @change="changeKindList" v-model="userChange" placeholder="活畜类别"
                                style="margin-right: 0.2rem;font-size:0.13rem">
                                <el-option v-for="item in livestockKindList" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                            <el-select v-model="userVariety" placeholder="活畜品种"
                                style="margin-right: 0.2rem;font-size:0.13rem">
                                <el-option v-for="item in liveVarietyList" :key="item.value" :label="item.label"
                                    :value="item.label">
                                </el-option>
                            </el-select>
                            <el-select v-model="userAge" placeholder="月龄" style="margin-right: 0.2rem;font-size:0.13rem">
                                <el-option v-for="item in ageList" :key="item.value" :label="item.label"
                                    :value="item.label">
                                </el-option>
                            </el-select>
                            <el-select v-model="userType" placeholder="监管状态" style="margin-right: 0.2rem;font-size:0.13rem">
                                <el-option v-for="item in userTypeList" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                            <el-input class="search_input" v-model="userName" id="myinput" @focus="focus" @blur="blur"
                                placeholder="输入耳标编号搜索活畜">
                            </el-input>
                            <img style="width:.23rem;height:.23rem;position: absolute; top: 0.1rem;left: 5.9rem;"
                                src="../../assets/search (1).png" alt="">
                            <div class="btn btn_1" @click="getList">搜索</div>
                            <div class="reset_btn btn_1" @click="reset">重置</div>
                            <span class="total">共计<span>{{ total }}</span>条</span>
                            <div v-if="(total > 10)" class="left_ l_f" @click="btnClick('left')"
                                :class="{ active: status === 'left' }">
                                <span class="el-icon-arrow-left"></span>
                            </div>
                            <div v-if="(total > 10)" class="right_ l_f" @click="btnClick('right')"
                                :class="{ active: statusRight === 'right' }">
                                <span class="el-icon-arrow-right"></span>
                            </div>
                        </div>
                        <dv-scroll-board ref="setDot" @click="archives" :config="config"
                            style="width:13.88rem;height:6rem;margin-top: .25rem;" />
                    </div>
                </div>
                <div v-if="isShow" class="big_box">
                    <div class="video_b">
                        <span class="el-icon-close close_icon" @click="closeIcon"></span>
                        <div class="show_video">
                            <!-- <video src="../../assets/login-bg-2.mp4" autoplay="autoplay" loop class="fillWidth"
                                                                        muted='muted'>
                                                                    </video> -->
                            <div class="quan">
                                <div class="cattle_">
                                    <span></span>
                                    <span>{{ currentDeviceInfo.mountLocation }}</span>
                                </div>
                            </div>
                            <div id="myVideo1" v-if="currentDeviceInfo.deviceType == 3 && !showImg"></div>
                            <video v-else autoplay controls width="100%" height="100%" muted id="myVideo2"
                                style="margin-top: .2rem;"></video>
                        </div>
                        <div class="listVideo">
                            <div class="list_video" v-for="(item, i) in deviceList" :key="i" @click="btnvideo(i)">
                                <span>{{ item.mountLocation }}</span>
                                <div class="box_img">
                                    <img src="../../assets/Aershan-niu-bg.jpg" alt="">
                                    <div v-if="videoNum == i" id="shoadow">正在播放中</div>
                                </div>

                            </div>
                            <!-- <div class="list_video" @click="btnvideo(1)">
                                                                        <span>{{ deviceList[0].mountLocation }}</span>
                                                                        <img src="../../assets/R-C.jpg" alt="">
                                                                        <div v-if="show1" id="shoadow">正在播放中</div>
                                                                    </div>
                                                                    <div v-if="deviceList.length > 1" class="list_video" @click="btnvideo(2)">
                                                                        <span>{{ deviceList[1].mountLocation }}</span>
                                                                        <img src="../../assets/R-C.jpg" alt="">
                                                                        <div v-if="show2" id="shoadow">正在播放中</div>
                                                                    </div> -->
                        </div>
                    </div>
                </div>
                <video src="../../assets/66.mp4" muted autoplay="autoplay" loop="loop" class="video_bg"></video>
            </div>
        </div>
    </Main>
</template>
  
<script>
import Main from "@/components/main.vue";
import Header from "../../components/headerXn.vue";
import cityJson from "@/assets/js/city.js";
import flvjs from "flv.js";
export default {
    components: {
        Main,
        Header,
        // XChart
    },
    data() {
        return {
            showImg: false,//萤石云
            showImg_1: false,//国标
            showImg_2: false,//无AI视频，显示图片
            isShow: false,//视频显示
            show1: true,
            show2: false,
            // house: ['1号牧场', '2号牧场'],
            command: '',
            config: {},
            config1: {},
            assortmentList: [],
            sheepList: [],
            sheep: [],//存储羊环形图信息
            baseArea: cityJson,
            userTypeList: [
                { value: '1', label: '监管中' },
                { value: '2', label: '未监管' },
            ],
            // 活畜类别
            livestockKindList: [
                { value: '1', label: '牛' },
                { value: '2', label: '羊' },
            ],
            liveVarietyList: [],
            ageList: [
                { value: '0', label: '1-12月' },
                { value: '1', label: '12-24月' },
                { value: '2', label: '24-36月' },
                { value: '3', label: '36-48月' },
                { value: '4', label: '48月以上' }
            ],
            userChange: '',
            userType: '',
            userVariety: '',
            userAge: '',
            userName: '',
            headerInfo: {},
            userInfo: {},
            numberList: [],
            deviceList: [],
            camerasList: [],
            decoder: {},
            camerasListItem: {},
            currentDeviceInfo: {},
            flvPlayer: null,
            flv: null,
            serviceStatus: 'cattle',
            status: '',
            statusRight: 'right',
            // 养殖户列表
            breederList: [],
            //  页码
            pageNum: 1,//第几页
            pageSize: 10,//一页几条
            total: 0,//总数
            // hasPreviousPage: false,//上一页
            // hasNextPage: false,//下一页
            info: {},//基础信息
            countList: {},//存栏活畜列表
            videoList: [],
            videoListItem: {},
            tableList: [],
            video: {},
            setDots: [],
            aas: [],
            videoModelShow: false,
            flag: false,
            videoNum: 0,
            firstList: [],//存储牧场
            pastureId: "",//开发 1593496704478535682
            // pastureId: "",//1593451117232713729
            userPhone: "" //获取视频列表的参数18247906555
        };
    },
    watch: {},
    created() {
        this.userInfo = JSON.parse(window.localStorage.getItem('NMYDATAUSERINFO'))
        this.headerInfo = {
            name: window.localStorage.getItem('screenName')
        }
        // window.localStorage.setItem('MYINFO', JSON.stringify(this.$route.params))
        this.info = JSON.parse(window.localStorage.getItem('MYINFO'))
        // 获取牧场
        this.getFirstList()
        // this.getDeviceList()
        this.getCount()
        // this. getLivestockList()
    },
    mounted() {
        this.getCount()
        //获取存栏活畜分布环形图
        this.getAssortment(this.serviceStatus)
        // 获取牧场监控
        this.getVideoList()
        // 获取表格数据
        this.getLivestockList()
    },
    methods: {
        focus() {
            var val = document.querySelector('#myinput')
            val['placeholder'] = ''
        },
        blur() {
            var val = document.querySelector('#myinput')
            val['placeholder'] = '输入耳标编号搜索活畜'
        },
        // 跳转活畜档案
        archives(val) {
            window.localStorage.setItem('INDEXNUM', JSON.stringify(val.rowIndex))
            window.localStorage.setItem('MYANIMALINFO', JSON.stringify(this.tableList[val.rowIndex]))
            this.$router.push({ name: 'archivesXn', query: { farmerName: this.info.farmerName } })
        },
        btnvideo(val) {
            this.videoNum = val
            // if (val == 1) {
            //     // this.show1 = true
            //     // this.show2 = false
            //     this.currentDeviceInfo = this.deviceList[0]
            // }
            // if (val == 2) {
            //     // this.show1 = false
            //     // this.show2 = true
            //     this.currentDeviceInfo = this.deviceList[1]
            // }
            this.$nextTick(() => {
                this.currentDeviceInfo = this.deviceList[val]
            })
            if (this.currentDeviceInfo.deviceType == 3) {
                this.$nextTick(() => {
                    this.getPlayUrl()
                })
            } else if (this.currentDeviceInfo.deviceType == 1) {
                this.$nextTick(() => {
                    this.getPasturePlayUrl()
                })
            } else if (this.currentDeviceInfo.deviceType == 2) {
                this.$nextTick(() => {
                    this.getLiveVideoUrl()
                })
            }
        },
        setVideo() {
            if (this.currentDeviceInfo.deviceType == 1 || this.currentDeviceInfo.deviceType == 2) {
                if (this.flvPlayer) {
                    this.flvPlayer.pause();
                    this.flvPlayer.unload();
                    this.flvPlayer.detachMediaElement();
                    this.flvPlayer.destroy();
                    this.flvPlayer = null;
                }
                if (flvjs.isSupported()) {
                    this.$nextTick(() => {
                        let typeValue = this.currentDeviceInfo.deviceType == 2 ? "flv" : "mp4";
                        var videoElement = document.getElementById("myVideo2");
                        this.flvPlayer = flvjs.createPlayer({
                            type: typeValue,
                            url: this.video,
                            isLive: true,
                            hasAudio: false,
                            hasVideo: true,
                            withCredentials: false,
                            autoplay: false,
                            cors: true,
                        });
                        this.flvPlayer.attachMediaElement(videoElement);
                        this.flvPlayer.load();
                        this.flvPlayer.play();
                    });
                }
                else {
                    this.$message({
                        type: "warning",
                        message: "加载失败",
                    });
                }
                // return
            } else if (this.currentDeviceInfo.deviceType == 3) {
                this.$nextTick(() => {
                    const _this = this
                    if (_this.decoder && _this.decoder.stop) {
                        _this.decoder.stop()
                        _this.decoder = {}
                        _this.camerasListItem = {}
                        if (document.getElementById('myVideo1').innerHTML != '') {
                            document.getElementById('myVideo1').innerHTML = ''
                        }
                    }
                    // const w = this.$refs.device_box.offsetWidth
                    // const h = this.$refs.device_box.offsetHeight
                    this.$nextTick(() => {
                        if (document.getElementById('myVideo1').innerHTML != '') {
                            document.getElementById('myVideo1').innerHTML = ''
                        }
                        _this.camerasListItem = this.video
                        _this.decoder = new this.$EZUIKit.EZUIKitPlayer({
                            id: 'myVideo1',
                            url: _this.camerasListItem.url,
                            accessToken: _this.camerasListItem.accessToken,
                            autoplay: true,
                            decoderPath: '/ezuikit',
                            // width: w,
                            // height: h,
                            splitBasis: 1,
                        })
                    })
                })
            } else {
                return
            }

        },
        changeKindList(val) {
            this.liveVarietyList = []
            this.userVariety = ''
            this.$http({
                url: 'screenapp-service/screenLiveStock/listLiveVarietyByCategoryName',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    "farmerId": this.info.farmerId,
                    "livestockKind": val,
                    dataFlag: 1
                },
            }).then(res => {
                const data = res.data;
                if (res.data.code === 200 && data.result) {
                    data.result.forEach((item, i) => {
                        this.liveVarietyList.push({ value: i, label: item })
                    })
                } else {
                    // this.$message.error(data);
                }
            })
        },
        videoShow() {
            this.isShow = true
            this.setVideo()
        },
        closeIcon() {
            this.isShow = false
            this.$nextTick(() => {
                this.command = this.firstList[0].pastureName
                this.pastureId = this.firstList[0].pastureId
                this.userPhone = this.firstList[0].userName
                this.videoNum = 0
                this.getDeviceList()
            })
        },
        getFirstList() {
            this.$http({
                url: 'screenapp-service/pastureSpace/list',
                method: 'post',
                //传递的参数
                data: {
                    userName: this.info.phone || ''
                },
            }).then(res => {
                const data = res.data;
                if (res.data.code === 200) {
                    this.firstList = data.result.filter(item => {
                        return Boolean(item.pastureName)
                    })
                    this.command = this.firstList[0].pastureName
                    this.pastureId = this.firstList[0].pastureId
                    this.userPhone = this.firstList[0].userName
                    // 获取牧场有几个视频
                    this.getDeviceList()
                } else {
                    // this.$message.error(data);
                }
            })
        },
        getDeviceList() {
            this.$http({
                url: 'ffsapp-service/pasture/selectPastureVideo',
                // url: 'https://gateway.east-mind.com/ffsapp-service/pasture/selectPastureVideo',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    // "pastureId": this.pastureId,
                    "pastureId": this.pastureId,
                    "userPhone": this.userPhone
                    // "userPhone": this.basicsInfo.phone
                },
            }).then(res => {
                const data = res.data;
                if (res.data.code === 200) {
                    this.deviceList = data.result.list
                    if (document.getElementById('myPlayer')) { document.getElementById('myPlayer').innerHTML = '' }
                    this.showImg = false
                    this.showImg_1 = false
                    this.showImg_2 = false
                    if (this.deviceList.length > 0) {
                        this.currentDeviceInfo = this.deviceList[0]
                        if (this.currentDeviceInfo.deviceType == 2) {
                            this.getLiveVideoUrl()
                        } else if (this.currentDeviceInfo.deviceType == 1) {
                            this.getPasturePlayUrl()
                        } else {
                            this.getPlayUrl()
                        }
                    } else {
                        this.currentDeviceInfo = {}
                    }
                } else {
                    // this.$message.error(data);
                }
            })
        },
        getLiveVideoUrl() {
            this.$http({
                url: 'ffsapp-service/pasture/getLiveVideoUrl',
                // url: 'https://gateway.east-mind.com/ffsapp-service/pasture/getLiveVideoUrl',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    deviceCode: this.currentDeviceInfo.deviceCode,
                    ezvizId: this.currentDeviceInfo.ezvizId,
                    channelCode: this.currentDeviceInfo.channelCode
                },
            }).then(res => {
                const data = res.data;
                if (data.code === 200) {
                    if (data.result.code === 200) {
                        this.video = data.result.data
                        if (this.isShow) {
                            this.setVideo()
                            return
                        }
                        this.flv_destroy()
                        this.playerVideo(data.result.data)
                    } else {
                        this.showImg_2 = true
                        // this.$message.error(data.result.message);
                    }
                } else {
                    // this.$message.error(data.message);
                }
            })
        },
        getPlayUrl() {
            let params = {
                deviceCode: this.currentDeviceInfo.deviceCode,
                channelCode: this.currentDeviceInfo.channelCode
            }
            if (this.currentDeviceInfo.deviceType == 3) {
                params.ezvizId = this.currentDeviceInfo.ezvizId;
            }

            this.$http({
                url: 'ffsapp-service/ezviz/getPlayUrl',
                // url: 'https://gateway.east-mind.com/ffsapp-service/ezviz/getPlayUrl',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    deviceCode: this.currentDeviceInfo.deviceCode,
                    channelCode: this.currentDeviceInfo.channelCode,
                    ezvizId: this.currentDeviceInfo.ezvizId
                },
            }).then(res => {
                const data = res.data;
                if (data.code === 200) {
                    this.video = data.result
                    if (this.isShow) {
                        this.setVideo()
                        return
                    }
                    this.setCameras(data.result)
                } else if (data.code === 500 || data.message) {
                    this.showImg = true
                    // alert('111')
                    // this.$message.error(data.message);
                }
            })
        },
        getPasturePlayUrl() {
            this.$http({
                url: 'ffsapp-service/pasture/getPlayUrl',
                // url: 'https://gateway.east-mind.com/ffsapp-service/pasture/getPlayUrl',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    deviceCode: this.currentDeviceInfo.deviceCode,
                    channelCode: this.currentDeviceInfo.channelCode
                },
            }).then(res => {
                const data = res.data;
                if (data.code === 200) {
                    this.video = data.result.httpsFmp4
                    if (this.isShow) {
                        this.setVideo()
                        return
                    }
                    this.flv_destroy()
                    this.playerVideo(data.result.httpsFmp4)
                } else {
                    this.showImg_1 = true
                    // this.$message.error(data.message);
                }
            })
        },
        setCameras(item) {
            // setTimeout(() => {
            const _this = this
            // if (_this.decoder && _this.decoder.stop) {
            //     _this.decoder.stop()
            //     _this.decoder = {}
            //     _this.camerasListItem = {}
            //     document.getElementById('myPlayer').innerHTML = ''
            // }
            const w = this.$refs.device_box.offsetWidth
            const h = this.$refs.device_box.offsetHeight
            this.$nextTick(() => {
                // if (document.getElementById('myPlayer')) document.getElementById('myPlayer').innerHTML = ''
                _this.camerasListItem = item
                _this.decoder = new this.$EZUIKit.EZUIKitPlayer({
                    id: 'myPlayer',
                    url: _this.camerasListItem.url,
                    accessToken: _this.camerasListItem.accessToken,
                    autoplay: true,
                    decoderPath: '/ezuikit',
                    width: w,
                    height: h,
                    splitBasis: 1,
                })
            })
            // this.videoModelShow = true
            // }, 5000)

        },
        flv_destroy() {
            if (this.flvPlayer) {
                this.flvPlayer.pause();
                this.flvPlayer.unload();
                this.flvPlayer.detachMediaElement();
                this.flvPlayer.destroy();
                this.flvPlayer = null;
            }
        },
        playerVideo(url) {
            if (flvjs.isSupported()) {
                this.$nextTick(() => {
                    let typeValue = this.currentDeviceInfo.deviceType == 2 ? "flv" : "mp4";
                    var videoElement = document.getElementById("myVideo");
                    this.flvPlayer = flvjs.createPlayer({
                        type: typeValue,
                        url: url,
                        isLive: true,
                        hasAudio: false,
                        hasVideo: true,
                        withCredentials: false,
                        autoplay: false,
                        cors: true,
                    });
                    this.flvPlayer.attachMediaElement(videoElement);
                    this.flvPlayer.load();
                    this.flvPlayer.play();
                });
            } else {
                this.$message({
                    type: "warning",
                    message: "加载失败",
                });
            }
        },
        // selectLive(command) {
        //     this.currentDeviceInfo = command
        //     if (this.currentDeviceInfo.deviceType == 2) {
        //         this.getLiveVideoUrl()
        //     } else if (this.currentDeviceInfo.deviceType == 1) {
        //         this.getPasturePlayUrl()
        //     } else {
        //         this.getPlayUrl()
        //     }
        // },
        // 视频全屏
        screenFull() {
            this.decoder.fullScreen()
            // this.decoder.();
        },
        selectLive(command) {
            this.command = command.pastureName
            this.pastureId = command.pastureId
            this.userPhone = command.userName
            this.firstList.forEach((item, i) => {
                if (item.pastureId == command.pastureId) {
                    if (this.videoList[i]) this.videoListItem = this.videoList[i]
                }
            })
            // if (this.currentDeviceInfo.deviceType == 2) {
            //     this.getLiveVideoUrl()
            // } else if (this.currentDeviceInfo.deviceType == 1) {
            //     this.getPasturePlayUrl()
            // } else {
            //     this.getPlayUrl()
            // }
            // if (command == '1号牧场') {
            //     this.videoListItem = this.videoList[0]
            //     this.pastureId = '1593496704478535682'//开发
            //     // this.pastureId = ''//1593451117232713729

            // } else {
            //     this.videoListItem = this.videoList[1]
            //     this.pastureId = '1593498270497431554'//开发
            //     // this.pastureId = ''//1593452355491917825

            // }
            this.getDeviceList()
        },
        setDot() {
            var dataArr = []
            this.tableList.forEach(item => {
                for (var key in item) {
                    if (!item[key]) {
                        item[key] = '—'
                    }
                }
                dataArr.push([item.theEarEncipher, item.categoryName, item.liveVariety, item.monthAge, '', `<span class="set" style="width:6px;height:6px;display:inline-block;border-radius:3px;margin-right:6px;background-color:#A3D8D6"}"></span><span class="aa">${item.superviseStatus}</span>`, `<span style="border: 0.01rem solid rgba(0,117,126,0.3);padding:.05rem .1rem;color:#00D7D3;cursor:pointer;font-size:.1rem;background: rgba(255, 255, 255, 0.1);">查看档案</span>`])
            })
            this.config = {
                header: ['耳标编码', '活畜类别', '活畜品种', '月龄(月)', '', '监管状态', '操作'],
                data: dataArr,
                align: ['left', 'left', 'left', 'right', 'left', 'left', 'left'],
                columnWidth: [200, 250, 200, 200, 50, 200, 150],
                headerHeight: 40,
                rowNum: 9,
                waitTime: 2000
            }
            // var dom = this.$refs.setDot.dom
            this.$nextTick(() => {
                setInterval(() => {
                    this.setDots = document.querySelectorAll('.table .dv-scroll-board .rows .set')
                    this.aas = document.querySelectorAll('.table .dv-scroll-board .rows .aa')
                    this.setDots.forEach((item, i) => {
                        if (this.aas[i].innerHTML == '监管中') {
                            // item.classList.add('myStyle1')
                            item.style.backgroundColor = '#FF5A0E'
                        }
                        // else {
                        //     // item.classList.add('myStyle2')
                        //     item.style.backgroundColor = '#A3D8D6'
                        // }
                    })
                }, 0)
            })
        },
        // 返回上一层
        goBack() {
            this.$router.go(-1)
        },
        // 重置
        reset() {
            this.userChange = '',
                this.userType = '',
                this.userVariety = '',
                this.userAge = '',
                this.userName = '',
                this.status = ''
            this.statusRight = 'right'
            this.pageNum = 1
            this.getLivestockList()

        },
        // 翻页
        // 翻页
        btnClick(val) {
            if (val === 'left') {
                if (this.pageNum > 1 && this.total > 10) {
                    this.status = 'left'
                    this.statusRight = 'right'
                    if (this.pageNum <= 0) {
                        this.pageNum = 1
                        this.statusRight = 'right'
                        this.status = ''
                        return
                    }
                    this.pageNum--
                    this.pageNum == 1 ? this.status = '' : this.status = 'left'
                    this.flag = false
                    this.getLivestockList()
                } else {
                    this.status = ''
                }
            }
            if (val === 'right') {
                if (this.flag) return
                if (this.pageNum >= 0 && this.total > 10) {
                    this.status = 'left'
                    this.statusRight = 'right'
                    if ((this.pageNum * 10) >= this.total) {
                        this.pageNum = this.pageNum - 1
                        this.status = 'left'
                        this.statusRight = ''
                        this.flag = true
                        return
                    }
                    this.pageNum++
                    this.pageNum == Math.ceil((this.total / 10)) ? this.statusRight = '' : this.statusRight = 'right'
                    this.getLivestockList()
                } else {
                    this.statusRight = ''
                }
            }
        },
        // 牛羊切换
        serviceStatusBtn(val) {
            this.serviceStatus = val
            this.getAssortment(val)
        },
        getCount() {
            this.$http({
                url: 'screenapp-service/screenLiveStock/count',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    "farmerId": this.info.farmerId,
                    dataFlag: 1
                },
            }).then(res => {
                const data = res.data;
                if (res.data.code === 200 && data.result) {
                    this.countList = data.result
                    if (this.info.farmerName == '郑秉荣') {
                        this.countList.liveStockQuantity = '0'
                    }
                    if (this.info.farmerName == '沈奎尚') {
                        this.countList.cowSuperviseAmount = 130
                    }
                    console.log(this.countList,this.info.farmerName, '6666');
                    console.log(this.info, '5555');
                    this.numberList = String(this.countList.liveStockQuantity).split('')
                } else {
                    // this.$message.error(data);
                }
            })
        },

        getAssortment(val) {
            this.$http({
                url: 'screenapp-service/screenLiveStock/assortment',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    "farmerId": this.info.farmerId,
                    dataFlag: 1,
                },
            }).then(res => {
                const data = res.data;
                if (res.data.code === 200 && data.result) {
                    this.sheep = data.result.sheep
                    if (val == 'cattle') {
                        var sum = 0
                        data.result.cow.forEach(item => {
                            sum = sum + item.categoryQuantity
                            return sum
                        })
                        this.assortmentList = data.result.cow.map((item) => {
                            if (item.categoryName == '怀胎母牛') {
                                item.categoryName = '公牛犊'
                            }
                            item.name = item.categoryName
                            item.value = item.categoryQuantity
                            item.label = Math.round((item.categoryQuantity / sum * 100).toFixed(2)) + '%'
                            return item
                        })
                        // this.assortmentList.forEach(() => {
                        //     var item_cow = this.assortmentList[0]
                        //     this.assortmentList[0] = this.assortmentList[1]
                        //     this.assortmentList[1] = this.assortmentList[2]
                        //     this.assortmentList[2] = item_cow
                        // })
                    } else {
                        if (data.result.sheep) {
                            var sum_ = 0
                            data.result.sheep.forEach(item => {
                                sum_ = sum_ + item.categoryQuantity
                                return sum_
                            })
                            this.assortmentList = data.result.sheep.map((item) => {
                                item.name = item.categoryName
                                item.value = item.categoryQuantity
                                item.label = Math.round((item.categoryQuantity / sum_ * 100).toFixed(2)) + '%'
                                return item
                            })
                            this.sheepList = this.assortmentList
                        }
                    }
                    this.config1 = {
                        data: this.assortmentList,
                        color: ['#3AFFFB', '#7239EA', '#FFC700', '#165DFF', '#469f4b'],
                        radius: '65%',
                        activeRadius: '70%',
                        lineWidth: 35,
                        digitalFlopStyle: {
                            fontSize: 20
                        },
                        activeTimeGap: 2000
                    }
                } else {
                    // this.$message.error(data);
                }
            })
        },
        // 牧场监控
        getVideoList() {
            this.$http({
                url: 'screenapp-service/screenGrazingSpace/list',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    // "farmerId": this.info.farmerId
                    "farmerId": '1'
                },
            }).then(res => {
                const data = res.data;
                if (res.data.code === 200) {
                    this.videoListItem = data.result[0]
                    this.videoList = data.result
                } else {
                    // this.$message.error(data);
                }
            })
        },
        // 搜索
        getList() {
            this.pageNum = 1
            this.status = ''
            this.statusRight = 'right'
            this.getLivestockList()
        },
        // 活畜列表表格查询
        getLivestockList() {
            this.$http({
                url: 'screenapp-service/screenLiveStock/list/livestock',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    "farmerId": this.info.farmerId,
                    "pageNum": this.pageNum,
                    "pageSize": this.pageSize,
                    "theEarEncipher": this.userName,
                    // "livestockKind": this.userChange=='牛'?'1':this.userChange=='羊'?"2":'',
                    "livestockKind": this.userChange,
                    "liveVariety": this.userVariety,
                    "monthAge": this.userAge,
                    // "isSupervise": this.userType=='监管中'?'1':this.userType=='未监管'?"2":''
                    "isSupervise": this.userType,
                    dataFlag: 1
                },
            }).then(res => {
                const data = res.data;
                if (res.data.code === 200) {
                    if (data.result) {
                        this.total = data.result.total || 0
                        this.tableList = data.result.records || []
                        // for(var i=0;i<10;i++){
                        //     this.tableList.push(this.tableList[0])
                        // }
                        // this.hasPreviousPage = res.data.result.hasPreviousPage,//上一页
                        //     this.hasNextPage = res.data.result.hasNextPage//下一页
                        this.setDot()
                    }
                } else {
                    // this.$message.error(data);
                }
            })
        },
    },
};
</script>
<style lang="scss" scoped>
.main {
    width: 100%;

    .bank_title {
        position: relative;

        .gobcak {
            width: .875rem;
            height: .4375rem;
            position: absolute;
            z-index: 99;
            bottom: -0.2rem;
            left: 0.25rem;
            font-size: .2rem;
            font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
            font-weight: 400;
            color: #00E0DB;
            display: flex;
            align-items: center;
            cursor: pointer;

            img {
                width: .3rem;
                height: .3rem;
            }

            span {
                margin-left: .05rem;
            }
        }
    }

    .content {
        position: relative;
        padding: .25rem;
        box-sizing: border-box;
        // background: url('../../assets/bg-hhr.png');
        // background-size: 100% 100%;
        display: flex;
        min-height: 12.5rem;
        // min-height: calc(100vh - 1rem);

        .video_bg {
            position: absolute;
            top: 0;
            left: 0;
            z-index: -1;
            width: 100%;
            height: 100%;
        }

        .left {
            width: 8.88rem;
            height: 12rem;
            // background: linear-gradient(270deg, rgba(0, 223, 218, 0.05) 10%, rgba(0, 223, 218, 0) 83%);
            background: linear-gradient(270deg, rgba(0, 223, 218, 0) 10%, rgba(0, 223, 218, 0.1) 83%);
            border-left: 0.01rem solid rgba(0, 224, 219, 0.3);

            .info {
                width: 8.12rem;
                height: 2.38rem;
                background: rgba(0, 223, 218, 0.04);
                border-radius: 0.13rem 0.13rem 0.13rem 0.13rem;
                opacity: 1;
                margin-top: .45rem;
                margin-left: .51rem;
                display: flex;
                align-items: center;
                padding-right: .2rem;

                .img_box {
                    width: 1.25rem;
                    height: 1.25rem;
                    opacity: 1;
                    // border: 0.04rem solid #FFFFFF;
                    border-radius: 50%;
                    margin-left: .29rem;

                    img {
                        width: 100%;
                        height: 100%;
                        border-radius: 50%;

                    }
                }

                .info_ {
                    height: 1.25rem;
                    font-size: 0.18rem;
                    font-family: Source Han Sans CN-Normal, Source Han Sans CN;
                    font-weight: 400;
                    color: #00E0DB;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;

                    div {
                        span:nth-child(2) {
                            color: #FFFFFF;
                        }
                    }
                }

                .info_n {
                    min-width: 2.1rem;
                    margin-left: .29rem;
                }

                .info_a {
                    min-width: 2.53rem;
                    margin-left: .4rem;
                }
            }

            .video_title {
                width: 8.88rem !important;
                margin-top: .64rem;
                background: linear-gradient(119deg, rgba(0, 222, 217, 0.3) 19%, rgba(0, 223, 218, 0) 60%) !important;
            }

            .el-dropdown {
                min-width: 1.63rem;
                height: 0.38rem;
                line-height: .33rem;
                background: rgba(0, 223, 218, 0.0588);
                border-radius: 0rem 0rem 0rem 0rem;
                opacity: 1;
                border: 0.01rem solid rgba(0, 223, 218, 0.4);
                margin-right: .25rem;
                cursor: pointer;
            }

            .el-dropdown-link {
                display: flex;
                justify-content: space-between;
                align-items: center;
                background: transparent;
                // padding: 0.05rem 0.19rem;
                font-size: 0.15rem;
                font-family: Source Han Sans CN-Normal, Source Han Sans CN;
                font-weight: 400;
                color: #00E0DB;

                i {
                    margin-right: .1rem;
                }
            }

            .box {
                display: flex;
                margin-top: .43rem;
                margin-left: .78rem;

                .video_info {
                    display: flex;
                    flex-direction: column;


                    .video_item {
                        // display: flex;
                        // align-items: center;
                        font-size: 0.18rem;
                        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                        font-weight: 400;
                        color: #FFFFFF;
                        min-width: 1.83rem;

                        img {
                            width: .24rem;
                            height: .24rem;
                            margin-right: .28rem;

                        }

                        span:nth-child(3) {
                            font-weight: 700;
                            font-size: 0.2rem;
                        }

                    }
                }
            }

            .device_main {
                display: flex;
                // justify-content: center;
                margin-left: .45rem;
                align-items: center;
                margin-top: .25rem;
                position: relative;
                // cursor: pointer;

                .sky {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    // z-index: 999;
                    cursor: pointer;
                    background-color: transparent;
                }
            }

            .quan {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-top: .3rem;
                margin-left: .45rem;

                .cattle_ {
                    display: flex;
                    align-items: center;
                    font-size: 0.2rem;
                    font-family: Source Han Sans CN-Bold, Source Han Sans CN;
                    font-weight: bold;
                    color: #00E0DB;

                    span:nth-child(1) {
                        display: inline-block;
                        width: 0.11rem;
                        height: 0.2rem;
                        background: #00E0DB;
                        border-radius: 0rem 0rem 0rem 0rem;
                        opacity: 1;
                        margin-right: .15rem;
                    }
                }

                .screenFull {
                    display: flex;
                    align-items: center;
                    font-size: 0.2rem;
                    font-family: Source Han Sans CN-Bold, Source Han Sans CN;
                    font-weight: bold;
                    color: #00E0DB;
                    cursor: pointer;

                    img {
                        width: .25rem;
                        height: .25rem;
                        margin-right: .15rem;
                    }

                    span {
                        padding-right: .2rem;
                    }
                }
            }

            // .long {
            //     width: .44rem;
            //     height: 4.75rem;
            //     line-height: 4.75rem;
            //     background: rgba(0, 222, 217, 0.08);
            //     opacity: 1;
            //     margin-left: .25rem;
            //     text-align: center;
            //     cursor: pointer;

            //     span {
            //         font-size: .38rem;
            //         color: #00E0DB;
            //         opacity: 1;
            //         font-weight: 400;
            //     }
            // }

            .video_box {
                position: relative;
                // width: 7.63rem;
                width: 8.2rem;
                height: 5rem;
                padding: .2rem;
                border: 0.01rem solid rgba(0, 224, 219, 0.08);

                &::after {
                    position: absolute;
                    left: 0;
                    top: 0;
                    content: "";
                    width: .18rem;
                    height: .14rem;
                    border-left: 1px solid #00E0DB;
                    border-top: 1px solid #00E0DB;
                }

                &::before {
                    position: absolute;
                    right: 0;
                    top: 0;
                    content: "";
                    width: .18rem;
                    height: .14rem;
                    border-right: 1px solid #00E0DB;
                    border-top: 1px solid #00E0DB;
                }

                .top_box {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 100%;
                    height: .5rem;

                    &::after {
                        position: absolute;
                        left: 0;
                        bottom: 0;
                        content: "";
                        width: .18rem;
                        height: .14rem;
                        border-left: 1px solid #00E0DB;
                        ;
                        border-bottom: 1px solid #00E0DB;
                        ;

                    }

                    &::before {
                        position: absolute;
                        right: 0;
                        bottom: 0;
                        content: "";
                        width: .18rem;
                        height: .14rem;
                        border-right: 1px solid #00E0DB;
                        ;
                        border-bottom: 1px solid #00E0DB;
                        ;

                    }
                }

                .device_box {
                    // width: 7.23rem;
                    width: 7.8rem;
                    height: 4.6rem;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
            }

        }

        .right {
            width: 14.38rem;
            height: 12rem;
            // background: linear-gradient(90deg, rgba(0, 222, 217, 0.06) 0%, rgba(1, 34, 54, 0) 64%);
            background: linear-gradient(90deg, rgba(0, 222, 217, 0) 0%, rgba(1, 34, 54, 0.1) 64%);
            border-right: 0.01rem solid rgba(0, 224, 219, 0.3);
            margin-left: .25rem;

            .center {
                margin-top: .45rem;
                height: 3.73rem;
                padding: 0 .25rem 0 .49rem;
                display: flex;

                .left_ {
                    width: 7.89rem;
                    height: 100%;

                    .hand {
                        font-size: 0.25rem;
                        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
                        font-weight: 500;
                        color: #FFFFFF;
                    }

                    ul {
                        margin-top: .26rem;
                        display: flex;

                        li {
                            width: 0.56rem;
                            height: 0.63rem;
                            background: rgba(0, 224, 219, 0.05);
                            box-shadow: inset 0rem 0rem 0.08rem 0rem rgba(0, 224, 219, 0.2);
                            opacity: 1;
                            border: 0.01rem solid rgba(0, 224, 219, 0.1);
                            font-size: 0.45rem;
                            font-family: Source Han Sans CN-Bold, Source Han Sans CN;
                            font-weight: bold;
                            color: #00E0DB;
                            line-height: .63rem;
                            text-align: center;
                            margin-right: .14rem;
                        }
                    }

                    .box1 {
                        display: flex;
                        margin-top: .51rem;

                        .box_ {
                            display: flex;
                            flex-direction: column;

                            .box_item {
                                display: flex;
                                flex-direction: column;
                                font-size: 0.38rem;
                                font-family: AlibabaPuHuiTi-Bold, AlibabaPuHuiTi;
                                font-weight: bold;
                                color: #FFFFFF;

                                span:nth-child(2) {
                                    font-size: 0.18rem;
                                    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                                    margin-top: .2rem;
                                    font-weight: 400;
                                }
                            }
                        }
                    }
                }

                .right_ {
                    flex: 1;
                    height: 100%;

                    .r_ {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;

                        .r_l {
                            display: flex;
                            align-items: center;

                            span:nth-child(1) {
                                display: inline-block;
                                width: 0.11rem;
                                height: 0.2rem;
                                background: #00E0DB;
                                opacity: 1;
                            }

                            span:nth-child(2) {
                                display: inline-block;
                                font-size: 0.2rem;
                                font-family: Source Han Sans CN-Bold, Source Han Sans CN;
                                font-weight: bold;
                                color: #00E0DB;
                                margin-left: .15rem;
                                line-height: 0.23rem;
                            }
                        }

                        .r_r {
                            display: flex;
                            align-items: center;

                            span {
                                width: 0.44rem;
                                height: 0.23rem;
                                background: rgba(255, 255, 255, 0.05);
                                border-radius: 0.03rem 0.03rem 0.03rem 0.03rem;
                                // opacity: 1;
                                font-size: 0.13rem;
                                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                                font-weight: 400;
                                color: #7B8A89;
                                text-align: center;
                                line-height: .23rem;
                                cursor: pointer;
                            }

                            span:nth-child(2) {
                                margin-left: .13rem;
                            }

                        }
                    }
                }

                .pie_chart {
                    width: 100%;
                    height: 3.5rem;
                    display: flex;

                    #pieChart {
                        width: 50%;
                        height: 3.5rem;
                        cursor: pointer;
                    }

                    .lenged {
                        width: 50%;
                        height: 3.5rem;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;


                        div {
                            width: 80%;
                            cursor: pointer;
                            margin-top: .2rem;

                            span:nth-child(1) {
                                display: inline-block;
                                width: .09rem;
                                height: .09rem;
                                border-radius: 50%;
                                // background-color: red;
                            }

                            span:nth-child(2),
                            span:nth-child(3),
                            span:nth-child(4) {
                                display: inline-block;
                                min-width: .6rem;
                                font-size: 0.15rem;
                                font-family: SourceHanSansCN-Regular, SourceHanSansCN;
                                font-weight: 400;
                                color: #00E0DB;
                                margin-left: .13rem;
                            }
                        }
                    }
                }
            }

            .table {
                height: 6.75rem;
                margin: .6rem .25rem 0 .25rem;

                .search {
                    height: .38rem;
                    display: flex;
                    align-items: center;
                    position: relative;

                    .search_input.el-input {
                        width: 2.25rem !important;
                    }

                    .btn_1 {
                        width: 1.1rem;
                        height: 0.38rem;
                        font-size: 0.15rem;
                        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
                        font-weight: 400;
                        text-align: center;
                        line-height: .38rem;
                        cursor: pointer;
                    }

                    .btn {
                        background: #00E0DB;
                        border-radius: 0.03rem 0.03rem 0.03rem 0.03rem;
                        opacity: 1;
                        color: #032929;
                        margin-left: 0.2rem;
                    }

                    .reset_btn {
                        background: #013D4E;
                        border-radius: 0.03rem 0.03rem 0.03rem 0.03rem;
                        opacity: 1;
                        color: #00E0DB;
                        margin-left: 0.2rem;
                    }

                    .total {
                        display: block;
                        display: flex;
                        align-items: center;
                        min-width: 0.66rem;
                        height: 0.18rem;
                        font-size: 0.13rem;
                        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                        font-weight: 400;
                        color: #D8DFFE;
                        line-height: 0.18rem;
                        margin-left: .2rem;

                        span {
                            color: #FCD827;
                            font-size: .2rem;
                            padding: 0 .1rem;
                        }
                    }

                    .left_ {
                        margin-left: 1rem;
                        margin-right: .14rem;
                    }


                    .l_f {
                        width: 0.38rem;
                        height: 0.38rem;
                        background: rgba(255, 255, 255, 0.05);
                        border-radius: 0.03rem 0.03rem 0.03rem 0.03rem;
                        opacity: 1;
                        text-align: center;
                        line-height: .38rem;
                        cursor: pointer;
                        color: #7B8A8A;

                        span {
                            width: 0.1rem;
                            height: 0.17rem;
                            font-weight: 700;
                        }

                    }
                }
            }
        }

    }

    .server {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 0.48rem;
        background: linear-gradient(119deg, rgba(0, 222, 217, 0.3) 19%, rgba(0, 223, 218, 0) 88%);

        // padding-top: .24rem;
        .card_ {
            font-size: 0.23rem;
            font-family: SourceHanSansCN-Regular, SourceHanSansCN;
            font-weight: 400;
            color: #00E0DB;
            padding-left: .25rem;
        }

        .date {
            // margin-left: 1.2rem;
            color: #00E0DB;
            padding-right: 0.15rem;

            span {
                padding: .05rem;
                font-size: 0.13rem;
                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                background: rgba(255, 255, 255, 0.05);
                opacity: .5;
                font-weight: 400;
                cursor: pointer;
            }

            span:nth-child(2) {
                margin: 0 .13rem;
            }
        }
    }

    .active {
        background: rgba(255, 255, 255, 0.2) !important;
        // opacity: 1;
        color: #00E0DB !important;
    }

    .active_1 {
        color: #00FF9D !important;
    }

    .big_box {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 1);
        z-index: 99999;
    }

    .video_b {
        position: relative;
        // top: 25%;
        // left: 25%;
        width: 18.02rem;
        height: 10.14rem;
        background: url('../../assets/video_bg.png');
        background-size: 100% 100%;
        opacity: 1;
        display: flex;

        .close_icon {
            position: absolute;
            top: .25rem;
            right: .25rem;
            color: #00e0db;
            font-size: .3rem;
            cursor: pointer;
        }

        .show_video {
            width: 14rem;
            height: 8.68rem;
            margin-left: .4rem;
            margin-top: .2rem;

            .quan {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-top: .56rem;


                .cattle_ {
                    display: flex;
                    align-items: center;
                    font-size: 0.2rem;
                    font-family: Source Han Sans CN-Bold, Source Han Sans CN;
                    font-weight: bold;
                    color: #00E0DB;

                    span:nth-child(1) {
                        display: inline-block;
                        width: 0.11rem;
                        height: 0.2rem;
                        background: #00E0DB;
                        border-radius: 0rem 0rem 0rem 0rem;
                        opacity: 1;
                        margin-right: .15rem;
                    }
                }
            }

            #myVideo1 {
                margin-top: .2rem;
                // width: 14rem !important;
                width: 14.34rem !important;
                height: 8.68rem !important;
            }
        }

        .listVideo {
            display: flex;
            flex-direction: column;
            font-size: 0.15rem;
            font-family: Source Han Sans CN-Medium, Source Han Sans CN;
            font-weight: 500;
            color: #FFFFFF;
            overflow: auto;
            margin: 1rem 0 .1rem .55rem;

            .list_video {
                position: relative;
                // width: 3.2rem;
                width: 2.69rem;
                // width: 3.34rem;
                height: 1.8rem;
                margin-top: .4rem;
                cursor: pointer;

                span {
                    padding-top: .2rem !important;
                }

                .box_img {
                    position: relative;
                    width: 2.69rem;
                    height: 1.61rem;
                    margin-top: .2rem;
                }

                img {
                    width: 100%;
                    height: 100%;
                    // padding-top: .2rem;
                    // width: 3.2rem;
                    // width: 2.69rem;
                    // height: 1.8rem;
                }

                #shoadow {
                    position: absolute;
                    top: 0;
                    left: 0;
                    background-color: rgba(0, 0, 0, 0.5);
                    // margin-top: .37rem;
                    // width: 2.69rem;
                    // height: 1.61rem;
                    text-align: center;
                    line-height: 1.8rem;
                    width: 100%;
                    height: 100%;
                }

                // #video3 {
                //     margin-top: .2rem;
                //     width: 3.34rem;
                //     height: 1.6rem;
                // }
            }

            .list_video:nth-child(1) {
                margin-top: .2rem;
            }
        }
    }
}
</style>
<style lang="scss">
.details {
    .dv-digital-flop canvas {
        width: 80% !important;
        height: 80% !important;
        margin-left: .2rem !important;
    }

    .active-ring-name {
        font-size: .23rem !important;
        padding-top: .1rem;
    }

    .el-input__inner {
        width: 1.25rem;
        height: 0.38rem;
        background: rgba(0, 224, 219, 0.08);
        border: none;
        border-radius: 0.03rem;
        color: #FFFFFF !important;
        font-size: .13rem !important;
        border: 0.01rem solid rgba(0, 223, 218, 0.4);
    }

    .search_input.el-input .el-input__inner {
        width: 2.25rem !important;
    }

    .el-input__icon {
        color: #00E0DB;
    }


    .el-select .el-input .el-select__caret {
        color: #00E0DB !important;
        line-height: .33rem;

    }

    .search_input>.el-input__inner {
        padding: 0 0 0 .4rem;
    }

    // DataV
    .header {
        background: rgba(0, 224, 219, 0.08) !important;
        color: #00E0DB !important;

    }

    // DataV
    .header-item {
        font-size: .175rem !important;
        opacity: .85;
    }

    .header-item:nth-child(1) {
        text-align: left !important;
    }

    // .header-item:last-child {
    //     text-align: end !important;
    // }

    .rows {
        padding: .2rem 0 .4rem 0;
    }

    .row-item {
        background: transparent !important;
        // height: 0.44rem !important;
        // line-height: .44rem !important;
        // div:nth-child(7) {
        //     span {
        //         margin-left: .6rem !important;
        //     }
        // }
    }

    .row-item .ceil:nth-child(1) {
        text-align: left !important;
    }

    .row-item:hover {
        background-color: rgba(255, 255, 255, 0.05) !important;
    }

    .ceil {
        font-size: .15rem !important;
    }


    // 动态class
    // .myStyle {
    //     width: 6px;
    //     height: 6px;
    //     border-radius: 3px;
    //     display: inline-block;
    //     margin-right: 6px;
    // }

    // .myStyle1 {
    //     color: #FF5A0E;
    // }

    // .myStyle2 {
    //     color: #A3D8D6;
    // }

    // .ceil:first-child {
    //     color: #FFC300;
    // }

}
</style>